<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <core-card [actions]="[]">
        <div class="card-body pb-0">
          <div class="row">
            <div class="col-lg-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="getItems(); changeQueryParams()" />
            </div>
            <div class="col-lg-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select
                id="figure"
                [(ngModel)]="filter_figure"
                [searchable]="true"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                (ngModelChange)="getItems(); changeQueryParams()"
                [placeholder]="'SELECT_FIGURE' | translate"
              >
                <ng-template ng-label-tmp let-item="item" *ngIf="filter_figure !== 'all'">
                  <span>{{ "FIGURE" | translate }} : {{ item }} </span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item" *ngIf="filter_figure === 'all'">
                  <span>{{ "FIGURE" | translate }} : {{ "ALL_FEMALE_PLURAL" | translate }} </span>
                </ng-template>
                <ng-option value="all">{{ "ALL_FEMALE_PLURAL" | translate }}</ng-option>
                <ng-option *ngFor="let dep of _userFigureService.list" [value]="dep.name">{{ dep.name }}</ng-option>
              </ng-select>
            </div>
            <div class="col-lg-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'" has_capability="view_user_role">
              <ng-select
                id="role"
                [(ngModel)]="filter_role"
                [searchable]="true"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                (ngModelChange)="getItems(); changeQueryParams()"
                [placeholder]="'SELECT_ROLE' | translate"
              >
                <ng-template ng-label-tmp let-item="item" *ngIf="filter_role !== 'all'">
                  <span>{{ "ROLE" | translate }} : {{ item }} </span>
                </ng-template>
                <ng-template ng-label-tmp let-item="item" *ngIf="filter_role === 'all'">
                  <span>{{ "ROLE" | translate }} : {{ "ALL" | translate }} </span>
                </ng-template>
                <ng-option value="all">{{ "ALL" | translate }}</ng-option>
                <ng-option *ngFor="let role of _roleService.list" [value]="role.name">{{ role.name }}</ng-option>
              </ng-select>
            </div>
            <div class="col-lg-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select
                id="onBoardingFilter"
                [(ngModel)]="filter_onboarding"
                [searchable]="true"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                (ngModelChange)="getItems(); changeQueryParams()"
                [placeholder]="'ONBOARDING' | translate"
              >
                <ng-option value="all">{{ "ONBOARDING" | translate }}</ng-option>
                <ng-option [value]="1">{{ "COMPLETED" | translate }}</ng-option>
                <ng-option [value]="0">{{ "NOT_COMPLETED" | translate }}</ng-option>
              </ng-select>
            </div>
            <div class="col-lg-4 col-12 text-right" [ngClass]="{'col-lg-6': !_authenticationService.hasCapability('view_user_role')}">
              <div class="w-fit d-inline-block">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <button has_capability="create_user" routerLink="/dashboard/user/add/{{ user_type }}" class="btn btn-outline-primary ml-2">
                {{ "ADD" | translate }}
              </button>
            </div>
          </div>
          <div class="row mt-075">
            <div class="col-lg-6 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select
                id="skill-filter"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                [multiple]="true"
                [(ngModel)]="filter_skill"
                (clear)="filter_skill = [0]"
                (ngModelChange)="changeSkill(); changeQueryParams()"
              >
                <ng-option [value]="0">
                  <div class="font-small-4 font-weight-normal">{{ "ALL_SKILLS" | translate }}</div>
                </ng-option>
                <ng-option *ngFor="let skill of _skillService.list_enabled" [value]="skill.id">
                  <span class="font-small-4 font-weight-normal">{{ skill.name }}</span>
                </ng-option>
                <ng-template ng-multi-label-tmp let-items="items" let-items$="items$" let-index="index" let-clear="clear" *ngIf="filter_skill.includes(0)">
                  <div class="ng-select-selected-items">
                    <div *ngFor="let item of items; let last = last">
                      <div class="ng-value" *ngIf="item > 0">
                        <span>{{ item }}</span><span *ngIf="!last">, </span>
                      </div>
                      <div class="font-small-4 font-weight-normal empty" *ngIf="item < 1">
                        <span>{{ "ALL_SKILLS" | translate }}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-end" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <button has_capability="export_employees_list" *ngIf="user_type === 'employee'" class="btn btn-outline-secondary" (click)="openExportModal()">
                {{ "EXPORT_EXCEL" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pb-0">
          <!-- tabella desktop -->
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="50"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 160"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredUsers"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
            [sorts]="[{ prop: 'lastname', dir: 'asc' }]"
          >
            <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="complete_name" [sortable]="true" [width]="250" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img *ngIf="row.avatar?.length > 0" class="rounded-circle mr-1 cover" [src]="row.avatar" height="32" width="32" alt="datatable-avatar" />
                  <div class="avatar bg-light-primary mr-1 ml-0" *ngIf="!row.avatar || row.avatar.length < 1">
                    <div class="avatar-content text-uppercase">{{ row.firstname | initials }}{{ row.lastname | initials }}</div>
                  </div>
                  <div class="cell-line-height">
                    <a routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.complete_name }}</a>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BADGE_NUMBER' | translate" prop="number" [sortable]="false" width="170" has_capability="view_user_badge_number" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  {{ row.number.split("#")[0] }}<span class="text-primary">#{{ row.number.split("#")[1] }}</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FIGURE' | translate" prop="figure" [sortable]="true" width="190" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ row.figure ? row.figure : "-" }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ROLE' | translate" prop="role" [sortable]="true" width="170" has_capability="view_user_role" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ row.role ? row.role : "-" }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CITY' | translate" prop="working_city" [sortable]="true" width="110" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ row.working_city ? row.working_city : "-" }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ONBOARDING' | translate" prop="send_onboarding" [sortable]="true" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <div>{{ (row.send_onboarding ? "COMPLETED" : "NOT_COMPLETED") | translate }}</div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div ngbDropdown container="body">
                  <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                    <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                  </button>
                  <div ngbDropdownMenu>
                    <a *ngIf="row.email" [href]="'mailto:' + row.email" ngbDropdownItem> <i [data-feather]="'mail'" size="16" class="mr-50"></i> {{ "SEND_EMAIL" | translate }} </a>
                    <a *ngIf="row.private_phone" [href]="'tel:' + row.private_phone" ngbDropdownItem> <i [data-feather]="'phone'" size="16" class="mr-50"></i> {{ "CALL" | translate }} </a>
                    <a (click)="_userService.generateCV(row.hash)" ngbDropdownItem has_capability="generate_branded_cv">
                      <span [data-feather]="'file'" size="16" class="mr-50"></span> {{ "GENERATE_BRANDED_CV" | translate }}
                    </a>
                    <a routerLink="/dashboard/user/edit/{{ row.hash }}" ngbDropdownItem has_capability="edit_other_user">
                      <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                    </a>
                    <a (click)="deleteUser(row.hash)" ngbDropdownItem class="text-danger" has_capability="delete_user">
                      <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                    </a>
                    <a (click)="sendMailCredentials(row.hash)" ngbDropdownItem class="text-warning" has_capability="send_email_credentials">
                      <span [data-feather]="'key'" size="16" class="mr-50"></span> {{ "SEND_EMAIL_CREDENTIALS" | translate }}
                    </a>
                    <a (click)="openEditCompanyEmail(row.hash, row.email)" ngbDropdownItem class="text-secondary" has_capability="edit_user_company_email">
                      <span [data-feather]="'mail'" size="16" class="mr-50"></span> {{ "EDIT_COMPANY_EMAIL" | translate }}
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet -->
            <ngx-datatable-column [name]="user_type_name_singular" prop="firstname" [sortable]="true" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img *ngIf="row.avatar?.length > 0" class="rounded-circle mr-1 cover" src="{{ row.avatar }}" height="70" width="70" alt="datatable-avatar" />
                  <div class="avatar avatar-xl bg-light-primary mr-1 ml-0" *ngIf="!row.avatar || row.avatar.length < 1">
                    <div class="avatar-content text-uppercase">{{ row.firstname | initials }}{{ row.lastname | initials }}</div>
                  </div>
                  <div class="cell-line-height">
                    <a routerLink="/dashboard/user/profile/{{ row.hash }}" class="d-block">{{ row.complete_name }}</a>
                    <div class="mt-025">{{ row.figure ? row.figure : "-" }}</div>
                    <div class="mt-025" has_capability="view_user_role">{{ row.role ? row.role : "-" }}</div>
                    <div class="mt-025">{{ row.working_city ? row.working_city : "-" }}</div>
                    <div class="mt-025">{{ "ONBOARDING" | translate }}: {{ (row.send_onboarding ? "COMPLETED" : "NOT_COMPLETED") | translate }}</div>
                    <div class="d-flex align-items-center mt-075">
                      <a *ngIf="row.private_phone" [href]="'tel:' + row.private_phone" class="pr-1 text-secondary" [ngbTooltip]="'Chiama al  ' + row.private_phone" placement="left">
                        <i [data-feather]="'phone'" size="22" class="text-success"></i>
                      </a>
                      <a [href]="'mailto:' + row.email" class="text-tertiary pr-1" has_capability="generate_branded_cv">
                        <i [data-feather]="'mail'" size="22"></i>
                      </a>
                      <a routerLink="/dashboard/user/edit/{{ row.hash }}" class="text-secondary pr-1" ngbTooltip="Modifica" placement="right" has_capability="edit_other_user">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </a>
                      <a has_capability="delete_user" (click)="deleteUser(row.hash)" class="text-danger pr-1" ngbTooltip="Elimina" placement="top">
                        <i [data-feather]="'trash-2'" size="19"></i>
                      </a>
                      <a (click)="sendMailCredentials(row.hash)" class="text-warning" has_capability="send_email_credentials">
                        <span [data-feather]="'key'" size="16" class="mr-50"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </core-card>
    </section>
  </div>
</div>

<!-- Modal Add Email -->
<ng-template #editCompanyEmailModal let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="closeEditCompanyEmail()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ng-container *ngIf="editingCompanyEmail">
    <div class="modal-body" tabindex="0">
      <h3>{{ "ASSIGN_EMAIL" | translate }}</h3>
      <label [for]="'newEmail'">{{ "EMAIL" | translate }}<sup class="text-danger">*</sup></label>
      <input [(ngModel)]="editingCompanyEmail.email" name="newEmail" type="text" [id]="'newEmail'" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="closeEditCompanyEmail()" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button [disabled]="editingCompanyEmail.email.length < 3" (click)="updateEmailCompany()" type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </ng-container>
</ng-template>
<!-- / Modal Add Email -->
